class MobileVideo {
  constructor (element) {
    this.element = element
    this.source = this.element.dataset.videosrc
    this.type = this.element.dataset.videotype
    this.sourceMobile = this.element.dataset.videosrcmobile
    this.typeMobile = this.element.dataset.videotypemobile
    this.query = window.matchMedia('(min-width: 768px)')

    this.init()
  }

  init() {
    this.registerObserver()
    if (!this.query.matches) {
      this.updateSource({ matches: false })
    }
  }

  registerObserver() {
    this.query.addEventListener('change', query => this.updateSource(query))
  }

  updateSource({ matches }) {
    if (matches) {
      this.element.src = this.source
      this.element.type = this.type
    } else {
      this.element.src = this.sourceMobile
      this.element.type = this.typeMobile
    }
    this.element.parentElement.load()
  }
}

export default {
  selector: '[data-videosrc][data-videosrcmobile]',
  Source: MobileVideo
}
